import { FunctionComponent } from 'react';
import styles from '../styles.module.scss';
import PersonWalkingRegularIcon from '../../Icons/PersonWalkingRegularIcon';
import { PublicCourse } from '@cademy-package/sdk-component-types';

const BothTravelHighlight: FunctionComponent = () => {
    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <PersonWalkingRegularIcon />
            </span>
            <p>You travel to organiser or they travel to you</p>
        </li>
    );
};

const EducatorTravelsHighlight: FunctionComponent = () => {
    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <PersonWalkingRegularIcon />
            </span>
            <p>Delivered at your location</p>
        </li>
    );
};

const StudentTravelsHighlight: FunctionComponent = () => {
    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <PersonWalkingRegularIcon />
            </span>
            <p>Delivered at organisers&apos; location</p>
        </li>
    );
};

export const TravelHighlight: FunctionComponent<{ course: PublicCourse }> = ({ course }) => {
    if (course.type !== 'on-request') {
        return null;
    }
    if (!course.available_for_in_person_delivery) {
        return null;
    }
    if (course.educator_travel_settings.enabled && course.student_travel_settings.enabled) {
        return <BothTravelHighlight />;
    }
    if (course.educator_travel_settings.enabled) {
        return <EducatorTravelsHighlight />;
    }
    if (course.student_travel_settings.enabled) {
        return <StudentTravelsHighlight />;
    }
    return null;
};
